export default __webpack_public_path__ + "static/media/logo-full.dee645f7.svg";